module.exports = __webpack_public_path__ + "static/intlepos@3x-dc3c2b60a583e499732713d4da1d7eb0.png";